import type { DomainMapper } from '../types';

const gb: DomainMapper = {
  countryCode: 'gb',
  currency: 'GBP',
  domain: 'localhost:3011',
  environment: 'local',
  flagUrl: '/flags/GB-UKM.svg',
  languagePrimary: true,
  locale: 'en-GB',
  logoUrl: 'kahrs-logo',
  noRobots: true,
  sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-uk.xml',
  storyblokBasePath: 'uk',
  url: 'https://localhost:3011/uk',
  algoliaIndex: 'b2b-uk-en-GB-products',
  algoliaIndexAutocomplete: 'b2b-uk-en-GB-products_query_suggestions',
  algoliaIndexPages: 'content_',
  applicationId: 1161, // stage
  // applicationId: 1163, // prod
  subFolder: true,
  googleSiteVerification: '_khK6fTW4MrMqgixPOHH37F9BD7VJNkk3JXdFUMZthA',
  b2b: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: 'b2b',
    applicationId: 1161, // stage
    // applicationId: 1163, // prod
    algoliaIndex: 'b2b-uk-en-GB-products',
    algoliaIndexAutocomplete: 'b2b-uk-en-GB-products_query_suggestions',
    displayIncVat: false,
    default: false,
    productBasePath: 'b2b/product',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-uk.xml',
  },
  b2c: {
    enabled: true,
    purchaseEnabled: true,
    storyblokBasePath: '',
    applicationId: 1162, // stage
    // applicationId: 1164, // prod
    algoliaIndex: 'b2c-uk-en-GB-products',
    algoliaIndexAutocomplete: 'b2c-uk-en-GB-products_query_suggestions',
    displayIncVat: true,
    default: true,
    productBasePath: 'product',
    sitemapUrl: 'https://kahrs-api.test/storage/sitemaps/sitemap-uk-b2c.xml',
  },
  features: {
    fastOrder: true,
    backorders: false,
    cartSettings: true,
  },
} as DomainMapper;

export default gb;
